import { render, staticRenderFns } from "./userChange.vue?vue&type=template&id=53fc5d74&scoped=true&"
import script from "./userChange.vue?vue&type=script&lang=js&"
export * from "./userChange.vue?vue&type=script&lang=js&"
import style0 from "./userChange.vue?vue&type=style&index=0&id=53fc5d74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fc5d74",
  null
  
)

export default component.exports